import React from 'react';

import Popup from '../Popup';

interface ConfirmationDialogProps {
  open: boolean;
  title?: string | React.ReactNode;
  description?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
  loading?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  title = 'Confirmation',
  description,
  confirmLabel = 'Confirmer',
  cancelLabel = 'Annuler',
  onConfirm,
  onClose,
  loading = false,
}) => (
  <Popup
    isOpen={open}
    onClose={onClose}
    onConfirm={onConfirm}
    onCancel={onClose}
    title={title}
    confirmLabel={confirmLabel}
    cancelLabel={cancelLabel}
    loading={loading}
  >
    {description && (
      typeof description === 'string'
        ? <p className="text-gray-700">{description}</p>
        : description
    )}
  </Popup>
);

export default ConfirmationDialog;

